/** Display labels that belong to the ocean journey on the shipment board. */
export const OCEAN_STATUS_LABELS = new Set([
  "Partially Gate In at Loading Port",
  "Gate In at Loading Port",
  "Partially Loaded at Loading Port",
  "Loaded at Loading Port",
  "Partially Departed Loading Port",
  "Departed Loading Port",
  "Partially Transshipment",
  "Transshipment",
  "Partially Arrived at Discharge Port",
  "Arrived at Discharge Port",
  "Partially Discharged",
  "Discharged",
  "Partially Gate Out at Discharge Port",
  "Gate Out at Discharge Port",
]);

/** Display labels that belong to the air journey on the shipment board. */
export const AIR_STATUS_LABELS = new Set([
  "Partially Accepted by Carrier",
  "Accepted by Carrier",
  "Partially Manifested",
  "Manifested",
  "Partially Departed",
  "Departed",
  "Partially Arrived",
  "Arrived",
  "Partially Received from Flight",
  "Received from Flight",
  "Partially Released",
  "Released",
]);

/**
 * @param {string} statusLabel
 * @return {"ocean"|"air"|"shared"}
 */
export function laneTransportModeForStatusLabel(statusLabel) {
  if (OCEAN_STATUS_LABELS.has(statusLabel)) {
    return "ocean";
  }
  if (AIR_STATUS_LABELS.has(statusLabel)) {
    return "air";
  }
  return "shared";
}

export const SHIPMENT_TRANSPORT_FILTER_KEY = "shipmentBoardTransportMode";

/**
 * @return {"all"|"ocean"|"air"}
 */
export function readShipmentTransportFilter() {
  try {
    const value = localStorage.getItem(SHIPMENT_TRANSPORT_FILTER_KEY);
    if (value === "ocean" || value === "air") {
      return value;
    }
  } catch (_) {
    /* ignore */
  }
  return "all";
}

/**
 * @param {"all"|"ocean"|"air"} mode
 */
export function writeShipmentTransportFilter(mode) {
  try {
    localStorage.setItem(SHIPMENT_TRANSPORT_FILTER_KEY, mode);
  } catch (_) {
    /* ignore */
  }
}
